var _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.299,
    cy: 6.79907,
    r: 4.3563,
    transform: "rotate(-45 7.299 6.79907)",
    stroke: "black",
    strokeWidth: 1.08908
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.60938,
    y: 9.87952,
    width: 1.08908,
    height: 6.53445,
    rx: 0.544538,
    transform: "rotate(-45 9.60938 9.87952)",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.d957f31fa9753e7540ce2759ac10f5e5.svg";
export { ForwardRef as ReactComponent };